import { Helmet } from "react-helmet-async";

const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Dust Monitoring London",
    description:
      "Specialist construction dust monitoring services across London. Planning-compliant PM10 and PM2.5 boundary monitoring for contractors, developers, and demolition projects.",
    url: "https://dustmonitoringlondon.co.uk",
    telephone: "08004337914",
    email: "info@dustmonitoringlondon.co.uk",
    address: {
      "@type": "PostalAddress",
      addressLocality: "London",
      addressRegion: "Greater London",
      addressCountry: "GB",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "51.5074",
      longitude: "-0.1278",
    },
    areaServed: [
      {
        "@type": "City",
        name: "London",
        containedInPlace: {
          "@type": "Country",
          name: "United Kingdom",
        },
      },
      {
        "@type": "AdministrativeArea",
        name: "Greater London",
      },
    ],
    serviceType: [
      "Construction Dust Monitoring",
      "PM10 Monitoring",
      "PM2.5 Monitoring",
      "Real-Time Dust Monitoring",
      "Boundary Dust Monitoring",
      "Planning Compliance Monitoring",
      "Demolition Dust Monitoring",
      "Dust Complaint Investigation",
    ],
    priceRange: "££",
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "18:00",
    },
    sameAs: [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
